import { createContext, useContext, type ReactNode } from 'react';

import { createAdminApiClient, type AdminApiClient } from '../lib/api-client.js';

const defaultClient = createAdminApiClient();
const AdminApiContext = createContext<AdminApiClient>(defaultClient);

export function AdminApiProvider({
  client = defaultClient,
  children,
}: {
  client?: AdminApiClient;
  children: ReactNode;
}) {
  return <AdminApiContext.Provider value={client}>{children}</AdminApiContext.Provider>;
}

export function useAdminApi() {
  return useContext(AdminApiContext);
}
